import { useEffect, useState } from "react";
import api from "../api/api";
import SideNavLayout from "../customsidenav/sidenavlayout";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getPracticeId, practiceShortName } from "../config/practice";

dayjs.extend(utc);
dayjs.extend(timezone);

const Logs = () => {
  const practiseid = getPracticeId();

  const [allLogs, setAllLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [logs, setLogs] = useState([]);

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState("");

const fetchdata = async () => {
  try {
    setLoading(true);
console.log('get')
    const response = await api.get(`/v1/${practiseid}/otp-logs/get`);

    const data = response.data || [];
// const sortedData = [...data].sort((a, b) =>
//   dayjs(b.created_on).valueOf() - dayjs(a.created_on).valueOf()
// );
    setAllLogs(data);
    setFilteredLogs(data);

  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};;

  useEffect(() => {
    document.title = `${practiceShortName()} - Logs`;
    fetchdata();
  }, []);

  /* SEARCH FILTER */

  useEffect(() => {
    const filtered = allLogs.filter((item) =>
      item.mobilephone?.toString().includes(search)
    );

    setFilteredLogs(filtered);
    setPage(1);
  }, [search, allLogs]);

  /* PAGINATION */

  useEffect(() => {
    const start = (page - 1) * limit;
    const end = start + limit;

    setLogs(filteredLogs.slice(start, end));
  }, [page, limit, filteredLogs]);

  const totalCount = filteredLogs.length;
  const totalPages = Math.ceil(totalCount / limit);

  return (
    <SideNavLayout>
      <div className="p-6">

        <div className="bg-white rounded-xl shadow border border-gray-200">

          {/* Header */}

          <div className="flex justify-between items-center px-6 py-4 border-b">

            <h2 className="text-lg font-semibold text-gray-800">
              OTP Logs
            </h2>

            {/* Search */}

            <input
              type="text"
              placeholder="Search mobile number..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border rounded-lg px-3 py-1.5 text-sm w-64 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />

          </div>

          {/* Table */}

          <div className="overflow-x-auto">

            <table className="w-full text-sm text-left">

              <thead className="border-b text-gray-600 bg-gray-50">
                <tr>
                  {/* <th className="px-6 py-3">S/N</th> */}
                  <th className="px-6 py-3">Phone Number</th>
                  <th className="px-6 py-3">OTP</th>
                  <th className="px-6 py-3 pl-[4%]">Type</th>
                  <th className="px-6 py-3">Timestamp</th>
                </tr>
              </thead>

              <tbody>

                {logs.map((item, index) => (
                  <tr
                    key={item.id}
                    className="border-b hover:bg-gray-50"
                  >

                    {/* <td className="px-6 py-3 font-medium">
                      {(page - 1) * limit + index + 1}
                    </td> */}

                    <td className="px-6 py-3">
                      {item.mobilephone}
                    </td>

                    {/* OTP */}

                    <td className="px-6 py-3 font-semibold text-gray-800">
                      {item.datalog}
                    </td>

                    <td className="px-6 py-3">
                      <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs">
                        {item.type}
                      </span>
                    </td>

                    {/* Timestamp */}

                    <td className="px-6 py-3">
                      {dayjs(item.created_on).format(
                        "ddd - MMM DD, YYYY hh:mma"
                      )}
                        {/* {dayjs.utc(item.created_on)
  .tz("America/Regina")
  .format("ddd - MMM DD, YYYY hh:mm A")} */}
                    </td>

                  </tr>
                ))}

              </tbody>
            </table>

          </div>

          {/* Pagination */}

          <div className="flex justify-between items-center px-6 py-4">

            <div className="text-sm text-gray-600">
              Showing {(page - 1) * limit + 1} to{" "}
              {Math.min(page * limit, totalCount)} of {totalCount}
            </div>

            <div className="flex items-center gap-4">

              {/* Rows per page */}

              <div className="flex items-center gap-2 text-sm">
                Rows per page
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value));
                    setPage(1);
                  }}
                  className="border rounded px-2 py-1"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              {/* Page controls */}

              <div className="flex items-center gap-2">

                <button
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                  className="px-3 py-1 border rounded disabled:opacity-40"
                >
                  Prev
                </button>

                <div className="px-4 py-1 bg-black text-white rounded">
                  {page}
                </div>

                <button
                  disabled={page === totalPages}
                  onClick={() => setPage(page + 1)}
                  className="px-3 py-1 border rounded disabled:opacity-40"
                >
                  Next
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* Loader */}

      <Backdrop open={loading} sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

    </SideNavLayout>
  );
};

export default Logs;